export default __webpack_public_path__ + "static/media/email_icon_big.63371f4c.png";